var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bus"},[(_vm.toast)?_c('toast',{attrs:{"toast":_vm.toast}}):_vm._e(),_vm._v(" "),(_vm.dialog)?_c('modal-dialog',{attrs:{"width":"5.6rem","dialog":_vm.dialog},on:{"close":function($event){_vm.dialog=null}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19669b09","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bus.vue
// module id = null
// module chunks = 